/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Range_ToInputs */

const en_shopping_range_to = /** @type {(inputs: Shopping_Range_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const de_shopping_range_to = /** @type {(inputs: Shopping_Range_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Shopping_Range_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_range_to = /** @type {((inputs?: Shopping_Range_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Range_ToInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_range_to(inputs)
	return en_shopping_range_to(inputs)
});